import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=f5a56c46&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
import style0 from "./Users.vue?vue&type=style&index=0&id=f5a56c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a56c46",
  null
  
)

export default component.exports